module.exports = "/_next/static/images/img-super-homepage-554d1438fadfd662654cf1e7b9b4e8a2.jpeg";